'use strict';

const { h } = require('preact');

const OptionMessage = props => {
  if (!props) {
    return null;
  }
  const { classes, text } = props;

  let messageClasses = 'details';
  if (classes) {
    messageClasses += ` ${classes}`;
  }

  return text
    ? h(
        'div',
        {
          class: messageClasses,
        },
        text
      )
    : null;
};

module.exports = OptionMessage;
